<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>资产折旧、摊销及纳税调整明细表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" tabletype="2024033102">
        <colgroup>
          <col style="width: 40px" />
          <col style="width: 80px" />
          <col style="width: 100px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
          <col style="width: 120px" />
        </colgroup>
        <thead>
          <tr>
            <td class="title01" rowspan="3">行次</td>
            <td class="title01" rowspan="3" colspan="2">项目</td>
            <td class="title01" colspan="3">账载金额</td>
            <td class="title01" colspan="5">税收金额</td>
            <td class="title01" rowspan="2">纳税调整金额</td>
          </tr>
          <tr>
            <td class="title01">资产原值</td>
            <td class="title01">本年折旧、摊销额</td>
            <td class="title01">累计折旧、摊销额</td>
            <td class="title01">资产计税基础</td>
            <td class="title01">税收折旧、摊销额</td>
            <td class="title01" style="width: 140px">享受加速折旧政策的资产按税收一般规定计算的折旧、摊销额</td>
            <td class="title01">加速折旧、摊销统计额</td>
            <td class="title01">累计折旧、摊销额</td>
          </tr>
          <tr>
            <td class="title01">1</td>
            <td class="title01">2</td>
            <td class="title01">3</td>
            <td class="title01">4</td>
            <td class="title01">5</td>
            <td class="title01">6</td>
            <td class="title01">7=5-6</td>
            <td class="title01">8</td>
            <td class="title01">9（2-5）</td>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="title01">1</td>
            <td colspan="2" class="td_l title01">一、固定资产（2+3+4+5+6+7）</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v1x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v1x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v1x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v1x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v1x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v1x4" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v1x4.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v1x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v1x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v1x8" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v1x8.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d9">{{ parseFloatNum(data.v1x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">2</td>
            <td class="td_l title01" colspan="2" style="width: 310px">（一）房屋、建筑物</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v2x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v2x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v2x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v2x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v2x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d9">{{ parseFloatNum(data.v2x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">3</td>
            <td class="td_l title01" colspan="2">（二）飞机、火车、轮船、机器、机械和其他生产设备</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v3x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v3x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v3x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v3x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v3x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v3x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d9">{{ parseFloatNum(data.v3x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">4</td>
            <td class="td_l title01" colspan="2">（三）与生产经营活动有关的器具、工具、家具等</td>
            <td class="d1"><el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v4x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v4x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v4x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v4x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">5</td>
            <td class="td_l title01" colspan="2">（四）飞机、火车、轮船以外的运输工具</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v5x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v5x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v5x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v5x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v5x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v5x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d9">{{ parseFloatNum(data.v5x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">6</td>
            <td class="td_l title01" colspan="2">（五）电子设备</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v6x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v6x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v6x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v6x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v6x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v6x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x8.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d9">{{ parseFloatNum(data.v6x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">7</td>
            <td class="td_l title01" colspan="2">（六）其他</td>
            <td class="d1"><el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v7x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v7x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v7x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v7x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">8</td>
            <td colspan="2" class="td_l title01">二、生产性生物资产（9+10）</td>
            <td class="d1">{{ parseFloatNum(data.v8x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v8x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v8x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v8x4.value) }}</td>
            <td class="d5">{{ parseFloatNum(data.v8x5.value) }}</td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">{{ parseFloatNum(data.v8x8.value) }}</td>
            <td class="d9">{{ parseFloatNum(data.v8x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">9</td>
            <td class="td_l title01" colspan="2">（一）林木类</td>
            <td class="d1"><el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v9x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v9x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v9x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v9x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v9x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">10</td>
            <td class="td_l title01" colspan="2">（二）畜类</td>
            <td class="d1"><el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v10x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v10x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v10x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v10x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v10x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">11</td>
            <td colspan="2" class="td_l title01">三、无形资产（12+13+14+15+16+17+18+19）</td>
            <td class="d1">{{ parseFloatNum(data.v11x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v11x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v11x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v11x4.value) }}</td>
            <td class="d5">{{ parseFloatNum(data.v11x5.value) }}</td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">{{ parseFloatNum(data.v11x8.value) }}</td>
            <td class="d9">{{ parseFloatNum(data.v11x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">12</td>
            <td class="td_l title01" colspan="2">（一）专利权</td>
            <td class="d1"><el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v12x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v12x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v12x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v12x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v12x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">13</td>
            <td class="td_l title01" colspan="2">（二）商标权</td>
            <td class="d1"><el-input-number v-model.trim="data.v13x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v13x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v13x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v13x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v13x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v13x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v13x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">14</td>
            <td class="td_l title01" colspan="2">（三）著作权</td>
            <td class="d1"><el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v14x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v14x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v14x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v14x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v14x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">15</td>
            <td class="td_l title01" colspan="2">（四）土地使用权</td>
            <td class="d1"><el-input-number v-model.trim="data.v15x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v15x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v15x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v15x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v15x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v15x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v15x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">16</td>
            <td class="td_l title01" colspan="2">（五）非专利技术</td>
            <td class="d1"><el-input-number v-model.trim="data.v16x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v16x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v16x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v16x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v16x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v16x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v16x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">17</td>
            <td class="td_l title01" colspan="2">（六）特许权使用费</td>
            <td class="d1"><el-input-number v-model.trim="data.v17x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v17x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v17x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v17x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v17x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v17x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v17x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">18</td>
            <td class="td_l title01" colspan="2">（七）软件</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v18x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v18x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v18x3" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v18x4" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x4.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v18x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x5.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v18x8" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x8.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d9">{{ parseFloatNum(data.v18x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">19</td>
            <td class="td_l title01" colspan="2">（八）其他</td>
            <td class="d1"><el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v19x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v19x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v19x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v19x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v19x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v19x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">20</td>
            <td colspan="2" class="td_l title01">四、长期待摊费用（21+22+23+24+25）</td>
            <td class="d1">{{ parseFloatNum(data.v20x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v20x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v20x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v20x4.value) }}</td>
            <td class="d5">{{ parseFloatNum(data.v20x5.value) }}</td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8">{{ parseFloatNum(data.v20x8.value) }}</td>
            <td class="d9">{{ parseFloatNum(data.v20x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">21</td>
            <td class="td_l title01" colspan="2">（一）已足额提取折旧的固定资产的改建支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v21x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v21x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v21x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v21x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v21x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v21x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v21x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">22</td>
            <td class="td_l title01" colspan="2">（二）租入固定资产的改建支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v22x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v22x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v22x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v22x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v22x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v22x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v22x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">23</td>
            <td class="td_l title01" colspan="2">（三）固定资产的大修理支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v23x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v23x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v23x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v23x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v23x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v23x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v23x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">24</td>
            <td class="td_l title01" colspan="2">（四）开办费</td>
            <td class="d1"><el-input-number v-model.trim="data.v24x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v24x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v24x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v24x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v24x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v24x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v24x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">25</td>
            <td class="td_l title01" colspan="2">（五）其他</td>
            <td class="d1"><el-input-number v-model.trim="data.v25x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v25x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v25x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v25x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v25x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v25x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v25x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">26</td>
            <td class="td_l title01" colspan="2">五、油气勘探投资</td>
            <td class="d1"><el-input-number v-model.trim="data.v26x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v26x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v26x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v26x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v26x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v26x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v26x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">27</td>
            <td class="td_l title01" colspan="2">六、油气开发投资</td>
            <td class="d1"><el-input-number v-model.trim="data.v27x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v27x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v27x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v27x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v27x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v27x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v27x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">28</td>
            <td rowspan="2" class="td_l title01">享受资产加速折旧（摊销）及一次性扣除（摊销）政策的资产加速折旧（摊销）额大于一般折旧（摊销）额的部分</td>
            <td align="left">
              <div>（一）加速折旧（摊销）</div>
              <span style="color: #6687ff; cursor: pointer">填写优惠事项</span>
            </td>
            <td class="d1">{{ parseFloatNum(data.v28x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v28x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v28x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v28x4.value) }}</td>
            <td class="d5">{{ parseFloatNum(data.v28x5.value) }}</td>
            <td class="d6">{{ parseFloatNum(data.v28x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v28x7.value) }}</td>
            <td class="d8">{{ parseFloatNum(data.v28x8.value) }}</td>
            <td class="d9">*</td>
          </tr>

          <tr class="tr">
            <td class="title01">29</td>
            <td align="left">
              <div>（二）一次性扣除（摊销）</div>
              <span style="color: #6687ff; cursor: pointer">填写优惠事项</span>
            </td>
            <td class="d1">{{ parseFloatNum(data.v29x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v29x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v29x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v29x4.value) }}</td>
            <td class="d5">{{ parseFloatNum(data.v29x5.value) }}</td>
            <td class="d6">{{ parseFloatNum(data.v29x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v29x7.value) }}</td>
            <td class="d8">{{ parseFloatNum(data.v29x8.value) }}</td>
            <td class="d9">*</td>
          </tr>

          <tr class="tr">
            <td class="title01">30</td>
            <td class="td_l title01" colspan="2">合计</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v30x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v30x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v30x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v30x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v30x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v30x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v30x4" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v30x4.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x4.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v30x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v30x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x5.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d6">{{ parseFloatNum(data.v30x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v30x7.value) }}</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v30x8" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v30x8.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v30x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v30x8.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d9">{{ parseFloatNum(data.v30x9.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">31</td>
            <td>附列资料</td>
            <td>全民所有制企业公司制改制资产评估增值政策资产</td>
            <td class="d1"><el-input-number v-model.trim="data.v31x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v31x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v31x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v31x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v31x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6" style="text-align: center">--</td>
            <td class="d7" style="text-align: center">--</td>
            <td class="d8"><el-input-number v-model.trim="data.v31x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9">{{ parseFloatNum(data.v31x9.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep, includes } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        for (let column = 1; column <= 9; column++) {
          if (![6, 7].includes(column)) {
            // 1-5列与8列 1行=2+3+4+5+6+7
            let res1 = new Big(0);
            for (let row = 2; row <= 7; row++) {
              res1 = res1.plus(data.value[`v${row}x${column}`].value);
            }

            data.value[`v1x${column}`].value = res1.round(2).toNumber();

            // 1-5列与8列 8行=9+10
            let res2 = new Big(0);
            for (let row = 9; row <= 10; row++) {
              res2 = res2.plus(data.value[`v${row}x${column}`].value);
            }

            data.value[`v8x${column}`].value = res2.round(2).toNumber();

            // 1-5列与8列 11行=12+13+14+15+16+17+18+19
            let res3 = new Big(0);
            for (let row = 12; row <= 19; row++) {
              res3 = res3.plus(data.value[`v${row}x${column}`].value);
            }

            data.value[`v11x${column}`].value = res3.round(2).toNumber();

            // 1-5列与8列 20行=21+22+23+24+25
            let res4 = new Big(0);
            for (let row = 21; row <= 25; row++) {
              res4 = res4.plus(data.value[`v${row}x${column}`].value);
            }

            data.value[`v20x${column}`].value = res4.round(2).toNumber();

            // 1-5列与8列 30行=1+8+11+20+26+27
            let res5 = new Big(0);
            [1, 8, 11, 20, 26, 27].forEach((row) => {
              res5 = res5.plus(data.value[`v${row}x${column}`].value);
            });

            data.value[`v30x${column}`].value = res5.round(2).toNumber();
          }
        }

        // 1-31行 9列=2-5
        for (let row = 1; row <= 31; row++) {
          data.value[`v${row}x9`].value = new Big(data.value[`v${row}x2`].value).minus(data.value[`v${row}x5`].value).round(2).toNumber();
        }

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1500px !important;

  table {
    tbody {
      tr {
        td {
          &:nth-of-type(2) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4" tabletype="2024033102">
  <colgroup>
    <col style="width: 40px" />
    <col style="width: 100px" />
    <col style="width: 100px" />
    <col style="width: 100px" />
    <col />
    <col />
    <col />
    <col />
    <col />
    <col />
    <col />
    <col style="width: 150px" />
    <col style="width: 150px" />
  </colgroup>
  <thead>
    <tr>
      <td class="title01" rowspan="3">行次</td>
      <td class="title01" rowspan="3" colspan="3">项目</td>
      <td class="title01" colspan="3">账载金额</td>
      <td class="title01" colspan="5">税收金额</td>
      <td class="title01" rowspan="2">纳税调整金额</td>
    </tr>
    <tr>
      <td class="title01">资产原值</td>
      <td class="title01">本年折旧、摊销额</td>
      <td class="title01">累计折旧、摊销额</td>
      <td class="title01">资产计税基础</td>
      <td class="title01">税收折旧、摊销额</td>
      <td class="title01" style="width: 140px">享受加速折旧政策的资产按税收一般规定计算的折旧、摊销额</td>
      <td class="title01">加速折旧、摊销统计额</td>
      <td class="title01">累计折旧、摊销额</td>
    </tr>
    <tr>
      <td class="title01">1</td>
      <td class="title01">2</td>
      <td class="title01">3</td>
      <td class="title01">4</td>
      <td class="title01">5</td>
      <td class="title01">6</td>
      <td class="title01">7=5-6</td>
      <td class="title01">8</td>
      <td class="title01">9（2-5）</td>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td class="title01">1</td>
      <td colspan="3" class="td_l title01">一、固定资产（2+3+4+5+6+7）</td>
      <td class="d1"><input type="text" value="0" readonly="readonly" class="i1 j1 input1" daan="1200737.50" /></td>
      <td class="d2"><input type="text" value="0" readonly="readonly" class="i2 j1 input1" daan="70211.77" /></td>
      <td class="d3"><input type="text" value="0" readonly="readonly" class="i3 j1 input1" daan="254611.80" /></td>
      <td class="d4"><input type="text" value="0" readonly="readonly" class="i4 j1 input1" daan="1200737.50" /></td>
      <td class="d5"><input type="text" value="0" readonly="readonly" class="i5 j1 input1" daan="70211.77" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" readonly="readonly" class="i8 j1 input1" daan="254611.80" /></td>
      <td class="d9"><input type="text" value="0" readonly="readonly" class="i9 j1 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">2</td>
      <td class="title01" rowspan="6" style="text-align: center">所有固定资产</td>
      <td class="td_l title01" colspan="2" style="width: 310px">（一）房屋、建筑物</td>
      <td class="d1"><input type="text" value="0" class="i1 j2 input2 i1_17" daan="650000.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j2 input2 i2_17" daan="20583.36" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j2 input2 i3_17" daan="104632.08" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j2 input2 i4_17" daan="650000.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j2 input2 i5_17" daan="20583.36" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j2 input2 i8_17" daan="104632.08" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j2 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">3</td>
      <td class="td_l title01" colspan="2">（二）飞机、火车、轮船、机器、机械和其他生产设备</td>
      <td class="d1"><input type="text" value="0" class="i1 j3 input2 i1_17" daan="385237.50" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j3 input2 i2_17" daan="22490.17" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j3 input2 i3_17" daan="39423.80" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j3 input2 i4_17" daan="385237.50" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j3 input2 i5_17" daan="22490.17" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j3 input2 i8_17" daan="39423.80" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j3 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">4</td>
      <td class="td_l title01" colspan="2">（三）与生产经营活动有关的器具、工具、家具等</td>
      <td class="d1"><input type="text" value="0" class="i1 j4 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j4 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j4 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j4 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j4 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j4 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j4 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">5</td>
      <td class="td_l title01" colspan="2">（四）飞机、火车、轮船以外的运输工具</td>
      <td class="d1"><input type="text" value="0" class="i1 j5 input2 i1_17" daan="136000.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j5 input2 i2_17" daan="21533.28" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j5 input2 i3_17" daan="91516.44" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j5 input2 i4_17" daan="136000.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j5 input2 i5_17" daan="21533.28" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j5 input2 i8_17" daan="91516.44" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j5 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">6</td>
      <td class="td_l title01" colspan="2">（五）电子设备</td>
      <td class="d1"><input type="text" value="0" class="i1 j6 input2 i1_17" daan="29500.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j6 input2 i2_17" daan="5604.96" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j6 input2 i3_17" daan="19039.48" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j6 input2 i4_17" daan="29500.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j6 input2 i5_17" daan="5604.96" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j6 input2 i8_17" daan="19039.48" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j6 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">7</td>
      <td class="td_l title01" colspan="2">（六）其他</td>
      <td class="d1"><input type="text" value="0" class="i1 j7 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j7 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j7 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j7 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j7 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j7 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j7 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">8</td>
      <td rowspan="20" class="title01">其中：享受固定资产加速折旧及一次性扣除政策的资产加速折旧额大于一般折旧额的部分</td>
      <td class="td_l title01" colspan="2">（一）重要行业固定资产加速折旧（不含一次性扣除）</td>
      <td class="d1"><input type="text" value="0" class="i1 i1_17 j8 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 i2_17 j8 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 i3_17 j8 input2" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 i4_17 j8 input2" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 i5_17 j8 input2" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 i6_17 j8 input2" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 i7_17 j8 input1" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 i8_17 j8 input2" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">9</td>
      <td class="td_l title01" colspan="2">（二）其他行业研发设备加速折旧</td>
      <td class="d1"><input type="text" value="0" class="i1 j9 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j9 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j9 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j9 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j9 input2 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j9 input2 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j9 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j9 input2 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">10</td>
      <td class="td_l title01" colspan="2">（三）特定地区企业固定资产加速折旧（10.1+10.2）</td>
      <td class="d1"><input type="text" value="0" class="i1 j10 input1 i1_17" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j10 input1 i2_17" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j10 input1 i3_17" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j10 input1 i4_17" readonly="readonly" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j10 input1 i5_17" readonly="readonly" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j10 input1 i6_17" readonly="readonly" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j10 input1 i7_17" readonly="readonly" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j10 input1 i8_17" readonly="readonly" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">10.1</td>
      <td class="td_l title01" colspan="2">1.海南自由贸易港企业固定资产加速折旧</td>
      <td class="d1"><input type="text" value="0" class="i1 j10_1 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j10_1 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j10_1 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j10_1 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j10_1 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j10_1 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j10_1 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j10_1 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">10.2</td>
      <td class="td_l title01" colspan="2">2.横琴粤澳深度合作区企业固定资产加速折旧</td>
      <td class="d1"><input type="text" value="0" class="i1 j10_2 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j10_2 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j10_2 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j10_2 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j10_2 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j10_2 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j10_2 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j10_2 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">11</td>
      <td class="td_l title01" colspan="2">（四）500万元以下设备器具一次性扣除（11.1+11.2）</td>
      <td class="d1"><input type="text" value="0" class="i1 j11 input1 i1_17" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j11 input1 i2_17" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j11 input1 i3_17" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j11 input1 i4_17" readonly="readonly" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j11 input1 i5_17" readonly="readonly" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j11 input1 i6_17" readonly="readonly" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j11 input1 i7_17" readonly="readonly" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j11 input1 i8_17" readonly="readonly" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">11.1</td>
      <td class="td_l title01" colspan="2">1.高新技术企业2022年第四季度(10月-12月）购置单价500万元以下设备器具一次性扣除</td>
      <td class="d1"><input type="text" value="0" class="i1 j11_1 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j11_1 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j11_1 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j11_1 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j11_1 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j11_1 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j11_1 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j11_1 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">11.2</td>
      <td class="td_l title01" colspan="2">2.购置单价500万元以下设备器具一次性扣除(不包含高新技术企业2022年第四季度购置)</td>
      <td class="d1"><input type="text" value="0" class="i1 j11_2 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j11_2 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j11_2 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j11_2 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j11_2 input2 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j11_2 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j11_2 input2 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j11_2 input2 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">12</td>
      <td class="td_l title01" colspan="2">（五）500万元以上设备器具一次性扣除（12.1+12.2+12.3+12.4）</td>
      <td class="d1"><input type="text" value="0" class="i1 j12 input1 i1_17" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j12 input1 i2_17" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j12 input1 i3_17" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j12 input1 i4_17" readonly="readonly" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j12 input1 i5_17" readonly="readonly" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j12 input1 i6_17" readonly="readonly" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j12 input1 i7_17" readonly="readonly" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j12 input1 i8_17" readonly="readonly" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">12.1</td>
      <td class="title01" rowspan="3">中小微企业购置单价500万元以上设备器具</td>
      <td class="td_l title01">1.最低折旧年限为3年的设备器具一次性扣除</td>
      <td class="d1"><input type="text" value="0" class="i1 j12_1 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j12_1 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j12_1 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j12_1 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j12_1 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j12_1 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j12_1 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j12_1 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">12.2</td>
      <td class="td_l title01">2.最低折旧年限为4、5年的设备器具50%部分一次性扣除</td>
      <td class="d1"><input type="text" value="0" class="i1 j12_2 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j12_2 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j12_2 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j12_2 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j12_2 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j12_2 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j12_2 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j12_2 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">12.3</td>
      <td class="td_l title01">3.最低折旧年限为10年的设备器具50%部分一次性扣除</td>
      <td class="d1"><input type="text" value="0" class="i1 j12_3 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j12_3 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j12_3 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j12_3 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j12_3 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j12_3 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j12_3 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j12_3 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">12.4</td>
      <td class="td_l title01" colspan="2">4.高新技术企业2022年第四季度（10月-12月）购置单价500万元以上设备器具一次性扣除</td>
      <td class="d1"><input type="text" value="0" class="i1 j12_4 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j12_4 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j12_4 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j12_4 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j12_4 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j12_4 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j12_4 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j12_4 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">13</td>
      <td class="td_l title01" colspan="2">（六）特定地区企业固定资产一次性扣除（13.1+13.2）</td>
      <td class="d1"><input type="text" value="0" class="i1 j13 input1 i1_17" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j13 input1 i2_17" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j13 input1 i3_17" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j13 input1 i4_17" readonly="readonly" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j13 input1 i5_17" readonly="readonly" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j13 input1 i6_17" readonly="readonly" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j13 input1 i7_17" readonly="readonly" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j13 input1 i8_17" readonly="readonly" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">13.1</td>
      <td class="td_l title01" colspan="2">&nbsp;1.海南自由贸易港企业固定资产一次性扣除</td>
      <td class="d1"><input type="text" value="0" class="i1 j13_1 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j13_1 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j13_1 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j13_1 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j13_1 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j13_1 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j13_1 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j13_1 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">13.2</td>
      <td class="td_l title01" colspan="2">&nbsp;2.横琴粤澳深度合作区企业固定资产一次性扣除</td>
      <td class="d1"><input type="text" value="0" class="i1 j13_2 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j13_2 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j13_2 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j13_2 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j13_2 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j13_2 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j13_2 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j13_2 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">14</td>
      <td class="td_l title01" colspan="2">（七）技术进步、更新换代固定资产加速折旧</td>
      <td class="d1"><input type="text" value="0" class="i1 j14 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j14 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j14 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j14 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j14 input2 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j14 input2 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j14 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j14 input2 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>

    <tr class="tr">
      <td class="title01">15</td>
      <td class="td_l title01" colspan="2">（八）常年强震动、高腐蚀固定资产加速折旧</td>
      <td class="d1"><input type="text" value="0" class="i1 j15 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j15 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j15 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j15 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j15 input2 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j15 input2 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j15 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j15 input2 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>

    <tr class="tr">
      <td class="title01">16</td>
      <td class="td_l title01" colspan="2">（九）外购软件折旧加速折旧</td>
      <td class="d1"><input type="text" value="0" class="i1 j16 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j16 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j16 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j16 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j16 input2 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j16 input2 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j16 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j16 input2 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">17</td>
      <td class="td_l title01" colspan="2">（十）集成电路企业生产设备加速折旧</td>
      <td class="d1"><input type="text" value="0" class="i1 j17 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j17 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j17 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j17 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j17 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j17 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j17 input2 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j17 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">18</td>
      <td class="td_l title01" colspan="3">二、生产性生物资产（19+20）</td>
      <td class="d1"><input type="text" value="0" readonly="readonly" class="i1 j18 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" readonly="readonly" class="i2 j18 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" readonly="readonly" class="i3 j18 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" readonly="readonly" class="i4 j18 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" readonly="readonly" class="i5 j18 input1 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" readonly="readonly" class="i8 j18 input1 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" readonly="readonly" class="i9 j18 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">19</td>
      <td class="td_l title01" colspan="3">（一）林木类</td>
      <td class="d1"><input type="text" value="0" class="i1 i1_17 j19 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 i2_17 j19 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 i3_17 j19 input2" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 i4_17 j19 input2" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 i5_17 j19 input2" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 i8_17 j19 input2" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 i9_17 j19 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">20</td>
      <td class="td_l title01" colspan="3">（二）畜类</td>
      <td class="d1"><input type="text" value="0" class="i1 j20 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j20 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j20 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j20 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j20 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j20 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j20 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">21</td>
      <td class="td_l title01" colspan="3">三、无形资产（22+23+24+25+26+27+28+29）</td>
      <td class="d1"><input type="text" value="0" readonly="readonly" class="i1 j21 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" readonly="readonly" class="i2 j21 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" readonly="readonly" class="i3 j21 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" readonly="readonly" class="i4 j21 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" readonly="readonly" class="i5 j21 input1 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" readonly="readonly" class="i8 j21 input1 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" readonly="readonly" class="i9 j21 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">22</td>
      <td rowspan="8">所有无形资产</td>
      <td class="td_l title01" colspan="2">（一）专利权</td>
      <td class="d1"><input type="text" value="0" class="i1 j22 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j22 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j22 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j22 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j22 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j22 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j22 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">23</td>
      <td class="td_l title01" colspan="2">（二）商标权</td>
      <td class="d1"><input type="text" value="0" class="i1 j23 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j23 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j23 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j23 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j23 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j23 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j23 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">24</td>
      <td class="td_l title01" colspan="2">（三）著作权</td>
      <td class="d1"><input type="text" value="0" class="i1 j24 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j24 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j24 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j24 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j24 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j24 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j24 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">25</td>
      <td class="td_l title01" colspan="2">（四）土地使用权</td>
      <td class="d1"><input type="text" value="0" class="i1 j25 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j25 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j25 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j25 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j25 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j25 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j25 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">26</td>
      <td class="td_l title01" colspan="2">（五）非专利技术</td>
      <td class="d1"><input type="text" value="0" class="i1 j26 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j26 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j26 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j26 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j26 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j26 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j26 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">27</td>
      <td class="td_l title01" colspan="2">（六）特许权使用费</td>
      <td class="d1"><input type="text" value="0" class="i1 j27 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j27 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j27 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j27 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j27 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j27 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j27 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">28</td>
      <td class="td_l title01" colspan="2">（七）软件</td>
      <td class="d1"><input type="text" value="0" class="i1 j28 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j28 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j28 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j28 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j28 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j28 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j28 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">29</td>
      <td class="td_l title01" colspan="2">（八）其他</td>
      <td class="d1"><input type="text" value="0" class="i1 j29 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j29 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j29 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j29 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j29 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j29 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j29 input1 i9_17" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">30</td>
      <td rowspan="7">其中：享受无形资产加速摊销及一次性摊销政策的资产加速摊销额大于一般摊销额的部分</td>
      <td class="td_l title01" colspan="2">（一）企业外购软件加速摊销</td>
      <td class="d1"><input type="text" value="0" class="i1 j30 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j30 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j30 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j30 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j30 input2 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j30 input2 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j30 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j30 input2 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>

    <tr class="tr">
      <td class="title01">31</td>
      <td class="td_l title01" colspan="2">（二）特定地区企业无形资产加速摊销（31.1+31.2）</td>
      <td class="d1"><input type="text" value="0" class="i1 j31 input1 i1_17" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j31 input1 i2_17" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j31 input1 i3_17" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j31 input1 i4_17" readonly="readonly" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j31 input1 i5_17" readonly="readonly" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j31 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j31 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j31 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">31.1</td>
      <td class="td_l title01" colspan="2">&nbsp;1.海南自由贸易港企业无形资产加速摊销</td>
      <td class="d1"><input type="text" value="0" class="i1 j31_1 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j31_1 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j31_1 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j31_1 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j31_1 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j31_1 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j31_1 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j31_1 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">31.2</td>
      <td class="td_l title01" colspan="2">&nbsp;2.横琴粤澳深度合作区企业无形资产加速摊销</td>
      <td class="d1"><input type="text" value="0" class="i1 j31_2 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j31_2 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j31_2 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j31_2 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j31_2 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j31_2 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j31_2 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j31_2 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">32</td>
      <td class="td_l title01" colspan="2">（三）特定地区企业无形资产一次性摊销（32.1+32.2）</td>
      <td class="d1"><input type="text" value="0" class="i1 j32 input1 i1_17" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j32 input1 i2_17" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j32 input1 i3_17" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j32 input1 i4_17" readonly="readonly" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j32 input1 i5_17" readonly="readonly" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j32 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j32 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j32 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">32.1</td>
      <td class="td_l title01" colspan="2">1.海南自由贸易港企业无形资产一次性摊销</td>
      <td class="d1"><input type="text" value="0" class="i1 j32_1 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j32_1 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j32_1 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j32_1 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j32_1 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j32_1 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j32_1 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j32_1 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">32.2</td>
      <td class="td_l title01" colspan="2">2.横琴粤澳深度合作区企业无形资产一次性摊销</td>
      <td class="d1"><input type="text" value="0" class="i1 j32_2 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j32_2 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j32_2 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j32_2 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j32_2 input1 i5_17" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j32_2 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j32_1 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" class="i8 j32_1 input1 i8_17" daan="0.00" /></td>
      <td class="d9" style="text-align: center">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">33</td>
      <td class="td_l title01" colspan="3">四、长期待摊费用（34+35+36+37+38）</td>
      <td class="d1"><input type="text" value="0" readonly="readonly" class="i1 j33 input1 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" readonly="readonly" class="i2 j33 input1 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" readonly="readonly" class="i3 j33 input1 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" readonly="readonly" class="i4 j33 input1 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" readonly="readonly" class="i5 j33 input1 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j33 input1 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j33 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">34</td>
      <td class="td_l title01" colspan="3">（一）已足额提取折旧的固定资产的改建支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j34 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j34 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j34 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j34 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j34 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j34 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j34 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">35</td>
      <td class="td_l title01" colspan="3">（二）租入固定资产的改建支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j35 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j35 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j35 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j35 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j35 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j35 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j35 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">36</td>
      <td class="td_l title01" colspan="3">（三）固定资产的大修理支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j36 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j36 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j36 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j36 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j36 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j36 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j36 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">37</td>
      <td class="td_l title01" colspan="3">（四）开办费</td>
      <td class="d1"><input type="text" value="0" class="i1 j37 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j37 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j37 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j37 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j37 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j37 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j37 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">38</td>
      <td class="td_l title01" colspan="3">（五）其他</td>
      <td class="d1"><input type="text" value="0" class="i1 j38 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j38 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j38 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j38 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j38 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j38 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j38 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">39</td>
      <td class="td_l title01" colspan="3">五、油气勘探投资</td>
      <td class="d1"><input type="text" value="0" class="i1 j39 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j39 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j39 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j39 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j39 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">40</td>
      <td class="td_l title01" colspan="3">六、油气开发投资</td>
      <td class="d1"><input type="text" value="0" class="i1 j40 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j40 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j40 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j40 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j40 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j40 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j40 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">41</td>
      <td class="td_l title01" colspan="3">合计（1+18+21+33+39+40）</td>
      <td class="d1"><input type="text" value="0" readonly="readonly" class="i1 j41 input1 i1_17" daan="1200737.50" /></td>
      <td class="d2"><input type="text" value="0" readonly="readonly" class="i2 j41 input1 i2_17" daan="70211.77" /></td>
      <td class="d3"><input type="text" value="0" readonly="readonly" class="i3 j41 input1 i3_17" daan="254611.80" /></td>
      <td class="d4"><input type="text" value="0" readonly="readonly" class="i4 j41 input1 i4_17" daan="1200737.50" /></td>
      <td class="d5"><input type="text" value="0" readonly="readonly" class="i5 j41 input1 i5_17" daan="70211.77" /></td>
      <td class="d6"><input type="text" value="0" readonly="readonly" class="i6 j41 input1 i6_17" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" readonly="readonly" class="i7 j41 input1 i7_17" daan="0.00" /></td>
      <td class="d8"><input type="text" value="0" readonly="readonly" class="i8 j41 input1 i8_17" daan="254611.80" /></td>
      <td class="d9"><input type="text" value="0" readonly="readonly" class="i9 j41 input1 i9_17" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01" colspan="2">附列资料</td>
      <td class="td_l title01" colspan="2">全民所有制企业公司制改制资产评估增值政策资产</td>
      <td class="d1"><input type="text" value="0" class="i1 j42 input2 i1_17" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j42 input2 i2_17" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j42 input2 i3_17" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j42 input2 i4_17" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j42 input2 i5_17" daan="0.00" /></td>
      <td class="d6" style="text-align: center">--</td>
      <td class="d7" style="text-align: center">--</td>
      <td class="d8"><input type="text" value="0" class="i8 j42 input2 i8_17" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 j42 input1 i9_17" daan="0.00" /></td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*none.*>/g, "");
  s = s.replace(/<input type="text".*readonly.*>/g, "{{ parseFloatNum(defaultValue) }}");
  s = s.replace(/<input type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
